import { render, staticRenderFns } from "./RoleInfoPopup.vue?vue&type=template&id=1afbcd40"
import script from "./RoleInfoPopup.vue?vue&type=script&lang=js"
export * from "./RoleInfoPopup.vue?vue&type=script&lang=js"
import style0 from "./RoleInfoPopup.vue?vue&type=style&index=0&id=1afbcd40&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports